const API_URL = window.location.hostname === 'gelisimpturkiye.com'
  ? 'https://gelisimpturkiye.com/api'
  : 'https://gelisimpturkiye.com/api';

export const jsonService = {
  // Kurslar
  async getCourses() {
    try {
      const response = await fetch(`${API_URL}/courses.php`, { cache: 'no-store' });
      const data = await response.json();
      return data.courses || [];
    } catch (error) {
      console.error('Kurslar yüklenirken hata:', error);
      return [];
    }
  },
  
  async saveCourses(courses) {
    try {
      const response = await fetch(`${API_URL}/courses.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ courses })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Kurslar kaydedilirken hata:', error);
      return false;
    }
  },

  // Blog yazıları
  async getBlogPosts() {
    try {
      const response = await fetch(`${API_URL}/blog.php`, { cache: 'no-store' });
      const data = await response.json();
      return data.posts || [];
    } catch (error) {
      console.error('Blog yazıları yüklenirken hata:', error);
      return [];
    }
  },
  
  async saveBlogPosts(posts) {
    try {
      const response = await fetch(`${API_URL}/blog.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ posts })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Blog yazıları kaydedilirken hata:', error);
      return false;
    }
  },

  // Seminerler
  async getEvents() {
    try {
      const response = await fetch(`${API_URL}/events.php`, { cache: 'no-store' });
      const data = await response.json();
      return data.events || [];
    } catch (error) {
      console.error('Seminerler yüklenirken hata:', error);
      return [];
    }
  },
  
  async saveEvents(events) {
    try {
      const response = await fetch(`${API_URL}/events.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ events })
      });
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error('Seminerler kaydedilirken hata:', error);
      return false;
    }
  }
}